import React, { useEffect } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { AnimatePresence, motion } from "framer-motion/dist/framer-motion";
import flusLogo from "assets/images/flus/fluster-logo.png";
import logoLeftBorder from "assets/images/flus/log0-left-icon.png";
import logoRightBorder from "assets/images/flus/logo-right-icon.png";
import { set_ready_to_vote } from "redux/game/action";
import { divVariants } from "shared/components/animations";
import FlusterTopPlayer from "./components/FlusterTopPlayer";
import FLUSAnswerer from "./screens/FLUSAnswerer";
import FLUSAroundTheHornQuestion from "./screens/FLUSAroundTheHornQuestion";
import FLUSAroundTheHornResult from "./screens/FLUSAroundTheHornResult";
import FLUSAsker from "./screens/FLUSAsker";
import FLUSFlusterIntro from "./screens/FLUSFlusterIntro";
import FLUSFlusterQuestion from "./screens/FLUSFlusterQuestion";
import FLUSFlusterResult from "./screens/FLUSFlusterResult";
import FLUSJoining from "./screens/FLUSJoining";
import FLUSOver from "./screens/FLUSOver";
import FLUSQuestion from "./screens/FLUSQuestion";
import FLUSResult from "./screens/FLUSResult";
import * as utils from "./utils";

const FLUS = () => {
  const {
    gameReducer: {
      currentUser,
      ready_to_vote,
      roomObj: {
        users,
        id,
        game_state: {
          status,
          asker,
          answerer,
          hands,
          question,
          points,
          vote,
          average_points,
          aroundthehorn_winner,
          game_parameters: { timer } = {}
        } = {}
      }
    },
    paramsReducer: { gameObj: { screens } = {} }
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const askerPlayer = users?.find((user) => user.player_id === asker);
  const answererPlayer = users?.find((user) => user.player_id === answerer);
  const otherPlayers = users?.filter((user) => user.player_id !== asker);
  const aroundTheHornWinnerPlayer = users?.find(
    (user) => user.player_id === aroundthehorn_winner
  );
  const otherFlusterPlayers = users?.filter(
    (user) => user.player_id !== answerer
  );
  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );
  const isAskerPlayer = currentPlayer?.player_id === asker;
  const isAnswererPlayer = currentPlayer?.player_id === answerer;
  const currentPlayerCard = hands?.find(
    (item) => item.player_id === currentPlayer.player_id
  );
  const currentPlayerVote =
    vote?.find((item) => item.id === currentPlayer.player_id) || {};

  useEffect(() => {
    status !== "Question" && dispatch(set_ready_to_vote(false));
  }, [status]);

  const leftPlayer = utils.getLeftPlayer(
    status,
    isAskerPlayer,
    isAnswererPlayer,
    ready_to_vote,
    askerPlayer,
    answererPlayer
  );
  const rightPlayer = utils.getRightPlayer(
    status,
    askerPlayer,
    isAskerPlayer,
    ready_to_vote,
    answererPlayer,
    currentPlayerVote
  );
  const getWord = utils.getWords(
    status,
    isAskerPlayer,
    ready_to_vote,
    currentPlayerVote,
    isAnswererPlayer
  );
  const getdescription = utils.getDescription(
    status,
    askerPlayer,
    answererPlayer,
    isAnswererPlayer
  );
  const show_bottom_text = utils.showBottomText(status, isAskerPlayer);
  const left_bottom_text = utils.leftBottomText(status, isAskerPlayer);
  const right_bottom_text = utils.rightBottomText(status, isAskerPlayer);
  const left_bold_bottomText = utils.leftBoldBottomText(status, isAskerPlayer);
  const right_bold_bottomText = utils.rightBoldBottomText(
    status,
    isAskerPlayer
  );

  return (
    <div
      className={`flus-wrapper ${
        isAskerPlayer && status === "Answerer" ? "asker-screen" : ""
      }  ${status === "Question" ? "question-screen" : ""} ${
        isAnswererPlayer && status === "Answerer" ? "answer-screen" : ""
      }   ${
        isAnswererPlayer && status === "Question" ? "special-card-screen" : ""
      }`}
    >
      <div className="flus-header">
        <img alt="" src={flusLogo} className="flus-logo" />
        <div className="logo-left-border">
          <img alt="" src={logoLeftBorder} className="logoLeftBorder" />
        </div>
        <div className="logo-right-border">
          <img alt="" src={logoRightBorder} className="logoRightBorder" />
        </div>
      </div>
      <AnimatePresence exitBeforeEnter>
        {status !== "Joining" && status !== "Over" && (
          <motion.div
            key={`flus-${
              !_.isEmpty(currentPlayerVote)
                ? "VoteClick"
                : ready_to_vote
                ? "ReadyVote"
                : status
            }`}
            variants={divVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="top-game-info"
          >
            <FlusterTopPlayer
              // key={`FLUS-${status}-${ready_to_vote ? "F1" : ""}-${
              //   !_.isEmpty(currentPlayerVote) ? "F2" : ""
              // } `}
              leftPlayer={leftPlayer}
              rightPlayer={rightPlayer}
              words={getWord}
              description={getdescription}
              isShowBottamText={show_bottom_text}
              rightBottomText={right_bottom_text}
              leftBottomText={left_bottom_text}
              leftBoldBottomText={left_bold_bottomText}
              rightBoldBottomText={right_bold_bottomText}
              ready_to_vote={ready_to_vote}
              isAroundTheHornResult={status === "AroundTheHornResult"}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <div className="flus-content">
        <AnimatePresence exitBeforeEnter>
          {status === "Joining" && (
            <FLUSJoining key="FLUS_0" users={users} screens={screens} />
          )}
          {status === "Asker" && (
            <FLUSAsker
              key="FLUS_1"
              roomId={id}
              screens={screens}
              askerPlayer={askerPlayer}
              otherPlayers={otherPlayers}
              isAskerPlayer={isAskerPlayer}
              currentPlayerCard={currentPlayerCard}
            />
          )}
          {status === "Answerer" && (
            <FLUSAnswerer
              key="FLUS_2"
              roomId={id}
              points={points}
              screens={screens}
              askerPlayer={askerPlayer}
              isAskerPlayer={isAskerPlayer}
              answererPlayer={answererPlayer}
              isAnswererPlayer={isAnswererPlayer}
              currentPlayerCard={currentPlayerCard}
            />
          )}

          {status === "Question" && (
            <FLUSQuestion
              key={`FLUS_3 ${
                ready_to_vote
                  ? "FLUS_3.1"
                  : !_.isEmpty(currentPlayerVote)
                  ? "FLUS_3.2"
                  : ""
              }`}
              roomId={id}
              askerPlayer={askerPlayer}
              answererPlayer={answererPlayer}
              isAskerPlayer={isAskerPlayer}
              isAnswererPlayer={isAnswererPlayer}
              askerAskedQuestion={question}
              currentPlayerCard={currentPlayerCard}
              askerReadytoVote={ready_to_vote}
              vote={vote}
              currentPlayerVote={currentPlayerVote}
              currentPlayerId={currentPlayer.player_id}
              timer={timer}
              screens={screens}
            />
          )}
          {(status === "FlusterIntro" || status === "AroundTheHornIntro") && (
            <FLUSFlusterIntro
              key="FLUS_4"
              roomId={id}
              currentPlayerId={currentPlayer.player_id}
              askerPlayer={askerPlayer}
              answererPlayer={answererPlayer}
              isAskerPlayer={isAskerPlayer}
              isAnswererPlayer={isAnswererPlayer}
              isAroundTheHornIntro={status === "AroundTheHornIntro"}
              screens={screens}
            />
          )}

          {status === "FlusterQuestion" && (
            <FLUSFlusterQuestion
              key="FLUS_5"
              roomId={id}
              timer={timer}
              currentPlayerId={currentPlayer.player_id}
              askerPlayer={askerPlayer}
              answererPlayer={answererPlayer}
              isAskerPlayer={isAskerPlayer}
              isAnswererPlayer={isAnswererPlayer}
              currentPlayerVote={currentPlayerVote}
              screens={screens}
            />
          )}
          {status === "FlusterResult" && (
            <FLUSFlusterResult
              key="FLUS_6"
              roomId={id}
              averagePoints={average_points}
              askerPlayer={askerPlayer}
              isAskerPlayer={isAskerPlayer}
              screens={screens}
            />
          )}
          {status === "AroundTheHornQuestion" && (
            <FLUSAroundTheHornQuestion
              key="FLUS_7"
              roomId={id}
              isAnswererPlayer={isAnswererPlayer}
              question={question}
              users={otherFlusterPlayers}
              answererPlayer={answererPlayer}
              screens={screens}
            />
          )}
          {status === "AroundTheHornResult" && (
            <FLUSAroundTheHornResult
              key="FLUS_8"
              roomId={id}
              isAnswererPlayer={isAnswererPlayer}
              answererPlayer={answererPlayer}
              aroundTheHornWinnerPlayer={aroundTheHornWinnerPlayer}
              screens={screens}
            />
          )}
          {status === "Result" && (
            <FLUSResult
              key="FLUS_9"
              roomId={id}
              averagePoints={average_points}
              answererPlayer={answererPlayer}
              isAnswererPlayer={isAnswererPlayer}
              screens={screens}
            />
          )}

          {status === "Over" && <FLUSOver key="FLUS_10" screens={screens} />}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default FLUS;
